// Shared field skin (DESIGN.md §8): 16px avoids iOS auto-zoom, 44px min-height for thumbs.
export const FIELD_CLASS = `
    block w-full min-h-11 sm:min-h-0 appearance-none rounded-xl border border-line-strong bg-white px-3 py-2
    text-base sm:text-sm text-gray-900 placeholder-gray-400 shadow-card
    transition-[color,background-color,border-color,box-shadow] duration-150 ease-out-soft
    hover:border-gray-400
    focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-400/30
    disabled:cursor-not-allowed disabled:bg-sunken disabled:text-gray-400 disabled:border-line disabled:shadow-none
`;
export const FIELD_LABEL_CLASS = "block font-medium text-gray-900";
//# sourceMappingURL=fieldClass.js.map